import React, { useEffect, useState } from 'react';
import { getBedTimeline } from '../services/api';

const BedHistoryModal = ({ bedId, bedNumber }) => {
    const [timeline, setTimeline] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (bedId) {
            loadTimeline();
        }
    }, [bedId]);

    const loadTimeline = async () => {
        try {
            setLoading(true);
            const res = await getBedTimeline(bedId);
            setTimeline(res.data);
        } catch (error) {
            console.error('Error loading timeline:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade" id={`historyModal${bedId}`} tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Histórico - Leito {bedNumber}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        {loading ? (
                            <div className="text-center p-3">
                                <div className="spinner-border text-primary" role="status"></div>
                            </div>
                        ) : (
                            <div className="timeline-list">
                                {timeline.length === 0 ? (
                                    <p className="text-muted text-center">Nenhum histórico recente.</p>
                                ) : (
                                    <ul className="list-group list-group-flush border-start border-2 ms-2">
                                        {timeline.map((item, idx) => (
                                            <li key={idx} className="list-group-item border-0 position-relative pb-4 ps-4">
                                                <div
                                                    className={`position-absolute top-0 start-0 translate-middle rounded-circle bg-${item.type === 'workflow' ? 'primary' : 'secondary'}`}
                                                    style={{ width: '12px', height: '12px', marginTop: '1.5rem', marginLeft: '-1px' }}
                                                ></div>
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <span className="fw-bold text-dark">{item.title}</span>
                                                    <small className="text-muted">{new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</small>
                                                </div>
                                                <div className="small text-muted mb-1">
                                                    {new Date(item.timestamp).toLocaleDateString()}
                                                </div>
                                                <p className="mb-0 small text-secondary">
                                                    {item.description}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BedHistoryModal;
